var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _g2, _path12, _g3, _g4, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.2963 179.042C138.625 179.042 171.317 146.349 171.317 106.021C171.317 65.6926 138.625 33 98.2963 33C57.968 33 25.2754 65.6926 25.2754 106.021C25.2754 146.349 57.968 179.042 98.2963 179.042Z",
    fill: "url(#paint0_linear_259_11987)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.69 45.7358H56.7985C51.7564 45.7358 47.6689 49.8233 47.6689 54.8654H146.82C146.82 49.8233 142.732 45.7358 137.69 45.7358Z",
    fill: "url(#paint1_linear_259_11987)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6689 54.6113H146.82V130.126C146.82 133.484 145.486 136.704 143.112 139.078C140.738 141.452 137.518 142.786 134.161 142.786H60.3282C56.9708 142.786 53.7508 141.452 51.3768 139.078C49.0027 136.704 47.6689 133.484 47.6689 130.126V54.6113Z",
    fill: "url(#paint2_linear_259_11987)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.776 64.1499H64.7442C63.3899 64.1499 62.292 65.2466 62.292 66.5995C62.292 67.9523 63.3899 69.0491 64.7442 69.0491H129.776C131.13 69.0491 132.228 67.9523 132.228 66.5995C132.228 65.2466 131.13 64.1499 129.776 64.1499Z",
    fill: "url(#paint3_linear_259_11987)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.776 84.9702H64.7442C63.3899 84.9702 62.292 86.0669 62.292 87.4198C62.292 88.7727 63.3899 89.8694 64.7442 89.8694H129.776C131.13 89.8694 132.228 88.7727 132.228 87.4198C132.228 86.0669 131.13 84.9702 129.776 84.9702Z",
    fill: "url(#paint4_linear_259_11987)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.776 105.782H64.7442C63.3899 105.782 62.292 106.879 62.292 108.232C62.292 109.585 63.3899 110.681 64.7442 110.681H129.776C131.13 110.681 132.228 109.585 132.228 108.232C132.228 106.879 131.13 105.782 129.776 105.782Z",
    fill: "url(#paint5_linear_259_11987)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.776 126.595H64.7442C63.3899 126.595 62.292 127.691 62.292 129.044C62.292 130.397 63.3899 131.494 64.7442 131.494H129.776C131.13 131.494 132.228 130.397 132.228 129.044C132.228 127.691 131.13 126.595 129.776 126.595Z",
    fill: "url(#paint6_linear_259_11987)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_259_11987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3024 101.319H29.6739C26.8919 101.319 24.6367 103.575 24.6367 106.356V155.852C24.6367 158.634 26.8919 160.889 29.6739 160.889H64.3024C67.0843 160.889 69.3395 158.634 69.3395 155.852V106.356C69.3395 103.575 67.0843 101.319 64.3024 101.319Z",
    fill: "url(#paint7_linear_259_11987)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4388 126.071H33.5386C32.6327 126.071 31.8984 126.805 31.8984 127.711V127.716C31.8984 128.622 32.6327 129.356 33.5386 129.356H60.4388C61.3446 129.356 62.0789 128.622 62.0789 127.716V127.711C62.0789 126.805 61.3446 126.071 60.4388 126.071Z",
    fill: "url(#paint8_linear_259_11987)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4543 149.192H33.7852C32.8872 149.192 32.1592 149.903 32.1592 150.781V150.786C32.1592 151.664 32.8872 152.375 33.7852 152.375H60.4543C61.3523 152.375 62.0803 151.664 62.0803 150.786V150.781C62.0803 149.903 61.3523 149.192 60.4543 149.192Z",
    fill: "url(#paint9_linear_259_11987)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4543 137.1H33.7852C32.8872 137.1 32.1592 137.811 32.1592 138.689V138.694C32.1592 139.571 32.8872 140.283 33.7852 140.283H60.4543C61.3523 140.283 62.0803 139.571 62.0803 138.694V138.689C62.0803 137.811 61.3523 137.1 60.4543 137.1Z",
    fill: "url(#paint10_linear_259_11987)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3742 108.957H35.5132C33.7719 108.957 32.3604 110.368 32.3604 112.109V114.291C32.3604 116.032 33.7719 117.444 35.5132 117.444H43.3742C45.1154 117.444 46.527 116.032 46.527 114.291V112.109C46.527 110.368 45.1154 108.957 43.3742 108.957Z",
    fill: "url(#paint11_linear_259_11987)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "path-group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.3577 160.461C91.8752 158.317 94.9249 158.317 95.4424 160.461L95.6997 161.527C95.8847 162.293 96.4829 162.891 97.2491 163.076L98.3149 163.333C100.459 163.851 100.459 166.9 98.3149 167.418L97.2491 167.675C96.4829 167.86 95.8847 168.458 95.6997 169.225L95.4424 170.291C94.9249 172.435 91.8752 172.435 91.3577 170.291L91.1004 169.225C90.9154 168.458 90.3172 167.86 89.551 167.675L88.4851 167.418C86.3411 166.9 86.3411 163.851 88.4851 163.333L89.551 163.076C90.3172 162.891 90.9154 162.293 91.1004 161.527L91.3577 160.461Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5178 33.3807C39.0354 31.2366 42.085 31.2366 42.6026 33.3807L42.8599 34.4465C43.0448 35.2127 43.643 35.8109 44.4092 35.9959L45.4751 36.2532C47.6191 36.7707 47.6191 39.8204 45.4751 40.3379L44.4092 40.5952C43.643 40.7802 43.0448 41.3784 42.8599 42.1446L42.6026 43.2104C42.085 45.3545 39.0354 45.3545 38.5178 43.2104L38.2605 42.1446C38.0756 41.3784 37.4774 40.7802 36.7112 40.5952L35.6453 40.3379C33.5013 39.8204 33.5013 36.7707 35.6453 36.2532L36.7112 35.9959C37.4774 35.8109 38.0756 35.2127 38.2605 34.4465L38.5178 33.3807Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3846 31.0504C96.6158 31.0504 97.6139 30.0523 97.6139 28.8211C97.6139 27.59 96.6158 26.5919 95.3846 26.5919C94.1534 26.5919 93.1554 27.59 93.1554 28.8211C93.1554 30.0523 94.1534 31.0504 95.3846 31.0504ZM95.3846 32.7224C97.5392 32.7224 99.2858 30.9757 99.2858 28.8211C99.2858 26.6666 97.5392 24.9199 95.3846 24.9199C93.23 24.9199 91.4834 26.6666 91.4834 28.8211C91.4834 30.9757 93.23 32.7224 95.3846 32.7224Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.976 93.5044C164.643 92.1984 165.849 91.0216 167.146 91.3863L170.6 92.3569C171.898 92.7215 172.314 94.3541 171.35 95.2955L168.782 97.8015C167.817 98.7429 166.195 98.2871 165.862 96.981L164.976 93.5044Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9353 83.1349C34.2417 82.8036 35.4169 84.0108 35.0506 85.3079L34.0755 88.7607C33.7092 90.0578 32.0761 90.4719 31.1359 89.5061L28.6333 86.9353C27.6931 85.9695 28.151 84.3481 29.4575 84.0168L32.9353 83.1349Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.251 165.739C140.557 165.408 141.732 166.615 141.366 167.912L140.391 171.365C140.025 172.662 138.392 173.076 137.451 172.11L134.949 169.539C134.009 168.573 134.466 166.952 135.773 166.621L139.251 165.739Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.869 63.5201C171.1 63.5201 172.098 62.5221 172.098 61.2909C172.098 60.0597 171.1 59.0616 169.869 59.0616C168.638 59.0616 167.64 60.0597 167.64 61.2909C167.64 62.5221 168.638 63.5201 169.869 63.5201ZM169.869 65.1921C172.024 65.1921 173.77 63.4455 173.77 61.2909C173.77 59.1363 172.024 57.3896 169.869 57.3896C167.714 57.3896 165.968 59.1363 165.968 61.2909C165.968 63.4455 167.714 65.1921 169.869 65.1921Z",
    fill: "#385BF8"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.006 151.945L145.538 141.45L172.405 165.79L172.404 165.791L173.839 167.091C175.232 168.353 176.066 170.115 176.157 171.992C176.249 173.868 175.59 175.703 174.327 177.094C173.063 178.486 171.298 179.319 169.42 179.41C167.541 179.501 165.703 178.844 164.31 177.582L162.876 176.282L162.873 176.285L136.006 151.945Z",
    fill: "url(#paint13_linear_259_11987)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_259_11987)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.611 123.755C155.611 145.712 137.789 163.511 115.805 163.511C93.8215 163.511 76 145.712 76 123.755C76 101.799 93.8215 84 115.805 84C137.789 84 155.611 101.799 155.611 123.755ZM149.505 123.755C149.505 142.343 134.417 157.412 115.805 157.412C97.1934 157.412 82.1055 142.343 82.1055 123.755C82.1055 105.167 97.1934 90.0977 115.805 90.0977C134.417 90.0977 149.505 105.167 149.505 123.755Z",
    fill: "url(#paint14_linear_259_11987)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_259_11987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.805 157.416C134.417 157.416 149.505 142.347 149.505 123.759C149.505 105.17 134.417 90.1016 115.805 90.1016C97.1934 90.1016 82.1055 105.17 82.1055 123.759C82.1055 142.347 97.1934 157.416 115.805 157.416Z",
    fill: "url(#paint15_linear_259_11987)",
    fillOpacity: 0.2
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.903 123.76L133.541 114.113C134.443 113.158 134.938 111.89 134.92 110.577C134.901 109.264 134.37 108.01 133.441 107.082C132.511 106.153 131.256 105.624 129.941 105.605C128.627 105.586 127.357 106.08 126.401 106.982L116.742 116.629L107.104 106.982C106.64 106.492 106.083 106.1 105.465 105.828C104.846 105.557 104.18 105.412 103.505 105.403C102.83 105.393 102.159 105.519 101.534 105.773C100.908 106.026 100.34 106.403 99.862 106.88C99.3846 107.357 99.0077 107.924 98.7537 108.549C98.4997 109.174 98.3738 109.843 98.3833 110.518C98.3929 111.192 98.5378 111.858 98.8094 112.475C99.081 113.093 99.4738 113.649 99.9646 114.113L109.619 123.76L99.9646 133.407C99.4738 133.87 99.081 134.427 98.8094 135.044C98.5378 135.662 98.3929 136.327 98.3833 137.002C98.3738 137.676 98.4997 138.345 98.7537 138.97C99.0077 139.595 99.3846 140.163 99.862 140.64C100.34 141.117 100.908 141.493 101.534 141.747C102.159 142 102.83 142.126 103.505 142.117C104.18 142.107 104.846 141.962 105.465 141.691C106.083 141.42 106.64 141.028 107.104 140.537L116.763 130.89L126.423 140.537C127.387 141.386 128.64 141.835 129.924 141.794C131.209 141.752 132.43 141.223 133.337 140.314C134.245 139.404 134.771 138.184 134.809 136.9C134.847 135.617 134.393 134.368 133.541 133.407L123.903 123.76Z",
    fill: "#F84B7A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_259_11987",
    x: 17.6367,
    y: 92.3193,
    width: 70.7031,
    height: 85.5703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_11987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_11987",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_259_11987",
    x: 114.404,
    y: 15,
    width: 70.7031,
    height: 50.4321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_11987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_11987",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_259_11987",
    x: 72,
    y: 84,
    width: 87.6113,
    height: 87.5107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_11987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_11987",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_259_11987",
    x: 67.1055,
    y: 75.1016,
    width: 97.3994,
    height: 97.3149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_259_11987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_259_11987",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_259_11987",
    x1: 97.7334,
    y1: 9.22259,
    x2: 99.2293,
    y2: 265.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_259_11987",
    x1: 52,
    y1: 67,
    x2: 149,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_259_11987",
    x1: 44.6919,
    y1: 120.731,
    x2: 233.159,
    y2: 143.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_259_11987",
    x1: 62.2128,
    y1: 65.2806,
    x2: 132.012,
    y2: 71.7498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_259_11987",
    x1: 62.2128,
    y1: 86.1009,
    x2: 132.012,
    y2: 92.5701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_259_11987",
    x1: 62.2128,
    y1: 106.913,
    x2: 132.012,
    y2: 113.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_259_11987",
    x1: 62.2128,
    y1: 127.725,
    x2: 132.012,
    y2: 134.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_259_11987",
    x1: 23.2945,
    y1: 145.99,
    x2: 108.975,
    y2: 153.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_259_11987",
    x1: 31.8643,
    y1: 126.829,
    x2: 62.1366,
    y2: 128.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_259_11987",
    x1: 32.1253,
    y1: 149.927,
    x2: 62.1325,
    y2: 151.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_259_11987",
    x1: 32.1253,
    y1: 137.834,
    x2: 62.1325,
    y2: 139.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_259_11987",
    x1: 32.3443,
    y1: 110.915,
    x2: 46.603,
    y2: 111.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_259_11987",
    x1: 120.062,
    y1: 42.3211,
    x2: 202.995,
    y2: 58.9283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_259_11987",
    x1: 142.196,
    y1: 157.574,
    x2: 151.804,
    y2: 147.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_259_11987",
    x1: 75.9098,
    y1: 102.35,
    x2: 156.044,
    y2: 102.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_259_11987",
    x1: 115.805,
    y1: 90.1016,
    x2: 149.689,
    y2: 178.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateList);
export default __webpack_public_path__ + "static/media/empty-state-list.ae4bb943f906d557c92161f7193a7eda.svg";
export { ForwardRef as ReactComponent };